import styled from 'styled-components/macro'

import { CSSDimensionConstraints, overlayStyles } from '../../theme'
import { Box } from '../../layout/box'

export const OverlayBox = styled(Box)<{ constraints?: CSSDimensionConstraints }>`
  ${props => overlayStyles(props.constraints)}
`
